export const datatableTheme = {
    default: {
        text: {
            primary: '#2C3E50',
            secondary: '#7F8C8D',
        },
        background: {
            default: 'rgba(255, 255, 255, 0.92)',
        },
        context: {
            background: '#E74C3C',
            text: '#FFFFFF',
        },
        divider: {
            default: 'rgba(52, 73, 94, 0.1)',
        },
        button: {
            default: '#7F8C8D',
            focus: 'rgba(231, 76, 60, 0.24)',
            hover: 'rgba(231, 76, 60, 0.10)',
            disabled: 'rgba(127, 140, 141, 0.3)',
        },
        sortFocus: {
            default: 'rgba(231, 76, 60, 0.45)',
        },
        highlightOnHover: {
            default: 'rgba(236, 240, 241, 0.72)',
            text: '#2C3E50',
        },
        selected: {
            default: 'rgba(231, 76, 60, 0.10)',
            text: '#2C3E50',
        },
    },
    dark: {
        text: {
            primary: '#ffffff',
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(0,0,0,.12)'
        },
        background: {
            default: '#161e29'
        },
        context: {
            background: '#E74C3C',
            text: '#FFFFFF',
        },
        divider: {
            default: 'rgba(81, 81, 81, 0.3)',
        },
        button: {
            default: '#FFFFFF',
            focus: 'rgba(255, 255, 255, .54)',
            hover: 'rgba(255, 255, 255, .12)',
            disabled: 'rgba(255, 255, 255, .18)',
        },
        sortFocus: {
            default: 'rgba(255, 255, 255, .54)',
        },
        selected: {
            default: '#374151',
            text: '#FFFFFF',
        },
        highlightOnHover: {
            default: '#6B7280',
            text: '#FFFFFF',
        },
        striped: {
            default: 'rgba(0, 0, 0, .87)',
            text: '#FFFFFF',
        },
    }
}
